import { apiClient, updateUserUrl, usersUrl, corporateCustomerRegistrationUrl, companyUrl, userUrl } from '../http-common';
export function updateUser(payload) {
    return new Promise((resolve, reject) => {
        apiClient.put(updateUserUrl, payload).then(response => {
            if (response.status === 200) {
                resolve(response.data);
            }
        }).catch(err => reject(err));
    });
}
export function updateCompanyOwner(payload) {
    return new Promise((resolve, reject) => {
        apiClient.put(updateUserUrl, payload).then(response => {
            if (response.status === 200) {
                resolve(response.data);
            }
        }).catch(err => reject(err));
    });
}
export function registerNewUser(payload) {
    return new Promise((resolve, reject) => {
        apiClient.post(usersUrl, payload).then(response => {
            if (response.status === 200) {
                resolve(response.data);
            }
        }).catch(err => reject(err));
    });
}
export function companyRegisterEmail(payload) {
    return new Promise((resolve, reject) => {
        apiClient.post(corporateCustomerRegistrationUrl, payload).then(response => {
            if (response.status === 200) {
                resolve(response.data);
            }
        }).catch(err => reject(err));
    });
}
export function updateCompany(payload) {
    return new Promise((resolve, reject) => {
        apiClient.put(companyUrl, payload).then((response) => {
            if (response.status === 200) {
                resolve(response.data);
            }
        });
    });
}
export function checkEmail(email) {
    return new Promise((resolve, reject) => {
        apiClient.get(`${userUrl}/check-email-availability/${email}`).then((response) => {
            if (response.status === 200) {
                resolve(response.data);
            }
        });
    });
}
export function companyRegisterInterest(payload) {
    return new Promise((resolve, reject) => {
        apiClient.post(`${companyUrl}/pre-booking`, payload).then(response => {
            console.log('response', response);
            if (response.status === 201) {
                console.log('resolve', response.data);
                resolve(response.data);
            }
        }).catch(err => reject(err));
    });
}
